import { Injectable } from '@angular/core';


import { first, timeout, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

import { Role, RoleService } from '@sim/role';

@Injectable({
  providedIn: 'root'
})
export class RoleResolverService  {

  constructor(
    private readonly roleService: RoleService,
  ) {
  }

  resolve() {
    return this.roleService.role$.pipe(
      first(),  // Get first emission (even if undefined)
      timeout(5000),  // Timeout after 5 seconds
      catchError((error) => {
        console.warn('RoleResolverService: Timeout or error loading role, allowing route to proceed:', error);
        // Return undefined to allow route to proceed even without role
        return of(undefined);
      }),
    );
  }
}
